import type { BulkCellMutationsRequest } from './types';

/**
 * The API's request-body limit, counted in transmitted bytes, as its default deployment
 * configures it. The API refuses a larger body with 413 before reading it.
 */
export const REQUEST_BODY_MAX_BYTES = 16 * 1024 * 1024;

const utf8 = new TextEncoder();

/** The bytes a bulk cell request takes on the wire as the JSON body this client sends. */
export function bulkCellMutationsBodyBytes(body: BulkCellMutationsRequest): number {
  return utf8.encode(JSON.stringify(body)).byteLength;
}
